import React from 'react'
import Chart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { DateTime } from 'luxon'
import { useIntl } from 'react-intl'

const ColumnChart = ({ chartData }) => {
  const intl = useIntl()

  const options: ApexOptions = {
    fill: {
      colors: ['#5b9ad5'],
    },
    chart: {
      foreColor: '#59595B',
      redrawOnWindowResize: true,
      redrawOnParentResize: true,
      width: '100%',
      height: 30,
      type: 'bar',
      stacked: false,
      animations: {
        enabled: true,
      },
      toolbar: {
        show: false,
      },
    },

    tooltip: {
      enabled: true,
      y: {
        formatter: value => {
          return intl.formatNumber(value)
        },
        title: {
          formatter: () => 'Executed functions:',
        },
      },
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
      },
    },

    dataLabels: {
      enabled: false,
    },

    xaxis: {
      tickAmount: 6,
      labels: {
        rotate: 0,
        datetimeUTC: false,
        style: {
          fontSize: '11px',
        },
        formatter: value => {
          const date = new Date(value).toISOString()
          const datetime = DateTime.fromISO(date)
          const humanTimestamp = datetime.toFormat('dd MMM')
          return humanTimestamp
        },
      },
    },
  }

  return <Chart options={options} series={chartData} type="bar" height={200} />
}

export default ColumnChart
